<!--  ******************************************************  -->
<!--  CUSTOMER PRODUCTITEM CHANGE OWNER DIALOG                       -->
<!--    - Allows the user to change the customerProductItem owner   -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'PRODUCTITEM.CHANGE_OWNER' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="mat-typography dialogBody">


  <form class="example-form" #changeProductItemOwnerForm="ngForm">

    <!--  ************************************  -->
    <!--         CUSTOMER-PRODUCTITEM NAME             -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'PRODUCTITEM.NAME' | translate}}</mat-label>
      <input matInput required disabled type="text" name="productItemName" [value]="data.productItem.name">
    </mat-form-field>

    <!--  ************************************  -->
    <!--         CUSTOMER-PRODUCTITEM OWNER            -->
    <!--  ************************************  -->

    <mat-form-field class="fullWidthField">
      <mat-label>{{'PRODUCTITEM.OWNER' | translate}}</mat-label>

      <input type="text" matInput class="mat-typography" #customerSelect (focus)="customerSelect.select()" [matAutocomplete]="auto" [formControl]="customerSelectionControl" name="parentCustomerId" [(ngModel)]="parentCustomer" >

      <mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="displayFn" (optionSelected)="parentId = parentCustomer? parentCustomer.id : ''">
        <mat-option [disabled]="customer.id === parentId" *ngFor="let customer of filteredCustomers | async" [value]="customer"><span class="mat-typography">{{customer.title}}</span></mat-option>
      </mat-autocomplete>

    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="changeProductItemOwnerForm.invalid? true : checkSelection()" (click)="changeProductItemOwner()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
